import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import {
  api_endpoint,
  adminRoot,
  basename,
} from '../../constants/defaultValues';
import axios from 'axios';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2/dist/sweetalert2';
import {
  SURVEY_LIST_GET_LIST,
  SURVEY_LIST_ADD_ITEM,
  SURVEY_UPT_EULA,
} from '../actions';

import {
  getSurveyListSuccess,
  uptEULASuccess,
  getSurveyListError,
  addSurveyItemSuccess,
  addSurveyItemError,
} from './actions';

import surveyListData from '../surveyques.json';

const getSurveyListRequest = async () => {
  // eslint-disable-next-line no-return-await
  return await new Promise((success, err) => {
    setTimeout(() => {
      axios.post(api_endpoint + '/surveys', {}, { headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') } })
        .then(function (response) {
          surveyListData.data = response.data.data;
          localStorage.setItem('gpfkey', response.data.token)
          success(surveyListData.data);
        }).catch(function (error) {
          // handle error
          if (error == undefined || error.response == undefined || error.response.status == undefined) {
            alert('พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง');
            success(surveyListData.data);
          } else if (error.response.status == 401) {
            localStorage.removeItem('gpfsp');
            sessionStorage.setItem('previous', window.location.href);
            Swal.fire({
              title: 'Session Timeout',
              html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
              confirmButtonText: `ปิด`,
              icon: 'info',
              didClose: () => {
                window.location.href = (basename + "/user/login")
              }
            });
          }
        });
    }, 1000);
  })
    .then((response) => response)
    .catch((error) => error);
};

function* getSurveyListItems() {
  try {
    const response = yield call(getSurveyListRequest);
    yield put(getSurveyListSuccess(response));
  } catch (error) {
    // console.log(error);
    yield put(getSurveyListError(error));
  }
}

const addSurveyItemRequest = async (item) => {
  const items = surveyListData.data;
  // eslint-disable-next-line no-param-reassign
  item.id = uuidv4();
  // eslint-disable-next-line no-param-reassign
  // eslint-disable-next-line no-return-await,no-unused-vars
  return await new Promise((success, err) => {
    setTimeout(() => {
      axios({
        method: 'post',
        url: api_endpoint + '/survey',
        headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') },
        data: item
      }).then(function (succ) {
        item.iid = succ.data.iid
        items.splice(0, 0, item);
        surveyListData.data = items;
        if (sessionStorage.getItem("aftergpf") === null) {
          window.location.href = basename + '/admin/survey/' + item.id
        } else {
          sessionStorage.removeItem("aftergpf")
        }
        success(items);
      }).catch(function (error) {
        if (error == undefined || error.response == undefined || error.response.status == undefined) {
          alert('พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง');
          success(surveyListData.data);
        } else if (error.response.status == 401) {
          localStorage.removeItem('gpfsp');
          sessionStorage.setItem('previous', window.location.href);
          Swal.fire({
            title: 'Session Timeout',
            html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
            confirmButtonText: `ปิด`,
            icon: 'info',
            didClose: () => {
              window.location.href = (basename + "/user/login")
            }
          });
        }
      });
    }, 1000);
  })
    .then((response) => response)
    .catch((error) => error);
};

const uptSurveyEulaRequest = async (item) => {
  // console.log('Redux zone', item);
  // console.log('Previous Data', surveyListData.data);
  for (let i = 0; i < surveyListData.data.length; i += 1) {
    try {
      if (
        surveyListData.data[i].id ===
        window.location.pathname.replace(basename + adminRoot + '/survey/', '')
      ) {
        surveyListData.data[i].agreement = item.agreement;
      }
    } catch (err) {
      window.location.href = basename + adminRoot + '/survey';
    }
  }
  // console.log('Updated Data', surveyListData.data);
};

function* addSurveyItem({ payload }) {
  try {
    const response = yield call(addSurveyItemRequest, payload);
    yield put(addSurveyItemSuccess(response));
  } catch (error) {
    yield put(addSurveyItemError(error));
  }
}

function* uptEula({ payload }) {
  try {
    const response = yield call(uptSurveyEulaRequest, payload);
    yield put(uptEULASuccess(response));
  } catch (error) {
    yield put(addSurveyItemError(error));
  }
}

export function* watchGetList() {
  yield takeEvery(SURVEY_LIST_GET_LIST, getSurveyListItems);
}

export function* wathcAddItem() {
  yield takeEvery(SURVEY_LIST_ADD_ITEM, addSurveyItem);
}

export function* wathcUptEula() {
  yield takeEvery(SURVEY_UPT_EULA, uptEula);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetList),
    fork(wathcAddItem),
    fork(wathcUptEula),
  ]);
}
